import { render } from "./Play.vue?vue&type=template&id=11144d42"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Play.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11144d42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11144d42', __exports__)) {
    api.reload('11144d42', __exports__)
  }
  
  module.hot.accept("./Play.vue?vue&type=template&id=11144d42", () => {
    api.rerender('11144d42', render)
  })

}


export default __exports__